import type { LocationQuery } from 'vue-router'

export const parseStringParam = (query: LocationQuery, key: string): string | null => {
  const value = query[key]

  if (value === null || value === undefined) return null

  return Array.isArray(value) ? String(value[0]) : String(value)
}

export const parseArrayParam = (query: LocationQuery, key: string): string[] => {
  const result: string[] = []

  for (const [paramKey, paramValue] of Object.entries(query)) {
    const match = paramKey.match(new RegExp(`^${key}\\[(\\d+)]$`))

    if (match && paramValue !== null) {
      const index = Number(match[1])
      result[index] = String(paramValue)
    }
  }

  return result.filter(Boolean)
}

/**
 * Links from app-main encode arrays as `key[0]=…`. Folds those keys into plain `key=…` arrays so the
 * filters only ever read one shape; `null` when there is nothing to rewrite. A bracket array replaces a
 * plain one under the same key.
 */
export const foldBracketArrayParams = (query: LocationQuery, keys: readonly string[]): LocationQuery | null => {
  const folded = keys
    .map(key => [key, parseArrayParam(query, key)] as const)
    .filter(([, values]) => values.length)

  if (!folded.length) return null

  const isFoldedBracketKey = (paramKey: string): boolean =>
    folded.some(([key]) => new RegExp(`^${key}\\[\\d+]$`).test(paramKey))

  return {
    ...Object.fromEntries(Object.entries(query).filter(([paramKey]) => !isFoldedBracketKey(paramKey))),
    ...Object.fromEntries(folded),
  }
}
